(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-media"] && !Shopify.designMode) return;
  try {
    /* Product media lazy hydration — self-contained, no library needed.
     Swaps data-src/data-srcset back in as slides approach the viewport.
     Extra horizontal rootMargin preloads the next carousel slide early. */
  (function () {
    if (window.__pmLazyInit) return;
    window.__pmLazyInit = true;

    function hydrate(img) {
      if (img.dataset.srcset) {
        img.srcset = img.dataset.srcset;
        img.removeAttribute('data-srcset');
      }
      if (img.dataset.src) {
        img.src = img.dataset.src;
        img.removeAttribute('data-src');
      }
      img.classList.remove('lazyload');
      img.classList.add('lazyloaded');
    }

    var io = null;

    function scan() {
      var imgs = document.querySelectorAll('img.lazyload[data-src]');
      if (!('IntersectionObserver' in window)) {
        imgs.forEach(hydrate); // ancient browser fallback: load everything
        return;
      }
      if (!io) {
        io = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                hydrate(entry.target);
                io.unobserve(entry.target);
              }
            });
          },
          /* top/bottom 300px, left/right 600px (carousel prefetch) */
          { rootMargin: '300px 600px 300px 600px' }
        );
      }
      imgs.forEach(function (img) {
        io.observe(img);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', scan);
    } else {
      scan();
    }

    /* Re-scan after section re-renders (theme editor, variant changes) */
    document.addEventListener('shopify:section:load', scan);
  })();
  } catch(e) { console.error(e); }
})();

})();
